import { useRef, useState } from "react";
import classNames from "classnames";
import { Button } from "../elements/Button";
import { useDismissOnOutsideClick } from "../hooks/useDismissOnOutsideClick";
import { SaveSplitButtonProps } from "./SaveSplitButton.types";

const buttonClassName = "entity-page__footer-btn--primary fw-medium";

/** Save, with the page's other ways of saving in a menu opening upwards from the caret. */
export function SaveSplitButton({
  options,
  disabled,
  savingAction,
  onSave,
  onSelect,
}: SaveSplitButtonProps) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useDismissOnOutsideClick(containerRef, open, () => setOpen(false));

  return (
    <div className="btn-group position-relative" ref={containerRef}>
      <Button
        text="Save"
        disabled={disabled}
        showSpinner={savingAction === "save"}
        className={classNames(buttonClassName, "rounded-start-2")}
        onClick={onSave}
      />
      <button
        type="button"
        className={classNames(
          "btn btn-info dropdown-toggle dropdown-toggle-split rounded-end-2",
          buttonClassName
        )}
        aria-label="More ways to save"
        aria-haspopup="menu"
        aria-expanded={open}
        disabled={disabled}
        onClick={() => setOpen((previous) => !previous)}
      />
      {open && (
        <ul className="dropdown-menu show position-absolute bottom-100 end-0 mb-1" role="menu">
          {options.map((option) => (
            <li key={option.id} role="none">
              <button
                type="button"
                role="menuitem"
                className="dropdown-item"
                title={option.description}
                disabled={disabled}
                onClick={() => {
                  setOpen(false);
                  onSelect(option);
                }}
              >
                {savingAction === `save:${option.id}` ? `${option.label}...` : option.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SaveSplitButton;
